import React, { memo, useCallback, useEffect, useState } from "react";
import { uploadFileToS3 } from "../../helper/utils";

import { useFetch } from "../../hooks/useFetch";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import _ from "lodash";
import DynamicButton from "../../component/button";
import BottomSheet from "./sheet";
import { useNavigate, useSearchParams } from "react-router-dom";
import { AToggleLoding } from "../../store/reducer/settings";
import { useDispatch } from "react-redux";
import CustomModal from "../../component/modal/CustomModal";
function WorkDetails() {
  // Hooks
  const router = useNavigate();
  const dispatch = useDispatch();
  const [query] = useSearchParams();
  const [loader, setLoader] = useState<boolean>(false);
  const [file, setFile] = useState<File | null>(null);
  const [preview, setPreview] = useState<any>([]);
  const state = useSelector((state: RootState) => state.invitation.invitation);
  const [open, setOpen] = useState<boolean>(false);
  const [token, setToken] = useState<string>("");
  const [mounted, setMounted] = useState<boolean>(false);
  const [Tokenresponse, Setresponse] = useState<any>({});
  const [CompantPlatform, setCompantPlatform] = useState<any>([]);
  const [popInfoPopup, setpopInfoPopup] = useState<any>(false);

  useEffect(() => {
    if (!mounted) setMounted(true);
    return () => setMounted(false);
  }, []);
  useEffect(() => {
    if (mounted) {
      const token = query.get("token");
      console.log("token");

      if (token) setToken(token);
      else router("/invalid");
    }
  }, [mounted]);
  // Constant
  const uploadImage = async (filee: any, item: any) => {
    if (filee) {
      dispatch(AToggleLoding());
      const { type: fileType, name: fileName } = filee;
      const type = fileName.split(".")[fileName.split(".").length - 1];
      const { data }: any = await useFetch.get("medias/b2c-signed-url", {
        params: {
          requestType: "upload",
          b2cReqId: Tokenresponse.b2cReqId,
          cnic: Tokenresponse.cnic,
          scope: "any",
          fileName: `${Tokenresponse.cnic}_${item.companyName}.${type}`,
          fileType,
          folderName: "b2c",
          key: state?.key,
        },
      });
      const url = data?.data?.signedUrl;
      await uploadFileToS3(url, filee);
      const urlPath = data?.data?.urlPath;
      const updatedfiles = await readFileObject(filee);
      const updatedData = CompantPlatform.map((v: any) => {
        if (v.index == item.index) {
          return {
            ...v,
            mediaproof: urlPath,
            previewfile: updatedfiles,
          };
        }
        return v;
      });
      console.log("__updatedData", updatedData);
      dispatch(AToggleLoding());
      setCompantPlatform(updatedData);
      console.log("__urlPath", urlPath);
      setOpen(true);
    }
  };

  useEffect(() => {
    if (token) {
      dispatch(AToggleLoding());
      useFetch
        .post("b2c/fetch-token", {
          token,
        })
        .then((res) => {
          const { data } = res;
          console.log("_data", data);
          Setresponse(data.data || {});
          dispatch(AToggleLoding());
        })
        .catch(() => {
          dispatch(AToggleLoding());
          return router("/invalid");
        });
    }
  }, [token]);
  useEffect(() => {
    console.log("_Tokenresponse", Tokenresponse);

    if (Tokenresponse?.companies) {
      var company = Tokenresponse?.companies.map((item: any, k: number) => {
        return {
          index: k,
          companyName: item,
          mediaproof: "",
          previewfile: "",
        };
      });
      setCompantPlatform(company);
    }
  }, [Tokenresponse]);

  const readFileObject = (file: any) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = () => {
        const result = reader.result as string;
        resolve(result);
      };

      reader.onerror = (err) => {
        reject(err);
      };

      reader.readAsDataURL(file);
    });
  };
  const handleNext = () => {
    setLoader(true);
    const updatedFileData = CompantPlatform.map((item: any) => {
      return {
        companyName: item.companyName,
        mediaProof: item.mediaproof,
      };
    });
    let body = {
      id: Tokenresponse.b2cReqId,
      step: 2,
      companyName: Tokenresponse.companies.join(", "),
      info: {
        companies: updatedFileData,
      },
    };
    return useFetch
      .post(`b2c/request/step`, {
        ...body,
      })
      .then((res: any) => {
        setLoader(false);
        console.log("updateB2CStep => ", res);
        router("?status=complete");
        return res?.data?.data?.id;
      })
      .catch((err) => {
        setLoader(false);
        console.log("ERROR", err?.response?.data);
        throw err;
      });
  };
  const validateData = (data: any) => {
    const isMediaproofMissing = data.some(
      (item: any) => !item.mediaproof || item.mediaproof === ""
    );

    return isMediaproofMissing;
  };
  const ondelteImage = (index: any) => {
    const updatedData = CompantPlatform.map((item: any, i: number) => {
      if (i === index) {
        return {
          ...item,
          mediaproof: "",
          previewfile: "",
        };
      }
      return item;
    });
    setCompantPlatform(updatedData);
  };
  console.log("__CompantPlatform", CompantPlatform);

  return (
    <>
      {popInfoPopup && (
        <CustomModal
          image={"./assets/prooftemp.png"}
          imgstyle={`h-[200px]`}
          paragraph={
            "Take a screenshot from each app you work with that clearly shows your name, profile, and activity, then upload it here."
          }
          onClose={function (): void {
            setpopInfoPopup(!popInfoPopup);
          }}
        />
      )}
      <div className="flex flex-col p-5 pt-10 justify-between h-[100vh] w-full overflow-x-hidden">
        <div>
          <div className="flex flex-col w-full items-center justify-center">
            <img src="/assets/uploadIcon.svg" alt="upload" />
            <h1 className="text-white text-center font-bold text-xl mt-3">
              Upload Proof
            </h1>
            <p className="text-center text-white text-[14px] mt-4">
              To verify your work details, upload a screenshot from each
              platform you work with. Make sure the screenshots clearly show
              your profile, activity and name.
            </p>
          </div>
          {CompantPlatform.map((item: any, key: number) => {
            return (
              <div>
                <div className="mt-9">
                  <h2 className="text-white text-[14px]">Platform {key + 1}</h2>
                  <div className="mt-3 border-b-[1px] border-b-[#172A46] pb-2 ">
                    <h3 className="text-white text-[13px]">
                      {item?.companyName}
                    </h3>
                  </div>
                </div>
                <div className="mt-6 flex-row  flex items-center">
                  <h2 className="text-white text-[12px]">Upload</h2>
                  <button onClick={() => setpopInfoPopup(!popInfoPopup)}>
                    <img
                      src="/assets/InfoIcon.png"
                      className="ml-2"
                      height={20}
                      width={20}
                      alt=""
                    />
                  </button>
                </div>

                <input
                  type="file"
                  className="hidden"
                  id={`file${key + 1}`}
                  accept=".jpg, .png, .jpeg, .gif, .bmp, .tif, .tiff|image/*"
                  onChange={(e: any) => uploadImage(e?.target?.files[0], item)}
                />
                {item?.previewfile == "" ? null : (
                  <div className="mt-6">
                    <h2 className="text-white text-[12px]">Attachment</h2>
                  </div>
                )}
                <div className="relative  w-[70px]">
                  {item?.previewfile ? (
                    <button
                      onClick={() => ondelteImage(key)}
                      className="h-5 w-5 absolute bg-white rounded-xl flex items-center justify-center -top-2 -right-2"
                    >
                      <h1>X</h1>
                    </button>
                  ) : null}
                  <label htmlFor={`file${key + 1}`}>
                    <div className="flex mt-4 p-2 h-[70px] w-[70px] rounded-[5px] bg-[#172A46] items-center justify-center overflow-hidden">
                      {item?.previewfile == "" ? (
                        <h1 className="text-white text-[30px]">+</h1>
                      ) : (
                        <img
                          src={item?.previewfile}
                          className="w-full h-full"
                          alt="img"
                        />
                      )}
                    </div>
                  </label>
                </div>
              </div>
            );
          })}
        </div>
        <div className="flex mt-10 w-full items-start justify-center">
          <DynamicButton
            isDisabled={validateData(CompantPlatform)}
            type="submit"
            isLoading={loader}
            onClick={handleNext}
          >
            CONFIRM
          </DynamicButton>
        </div>
      </div>
    </>
  );
}

export default memo(WorkDetails);
